angular
  .module 'filters'
  .filter 'dayOfMonth', ->
    (input) ->
      if input
        moment(input, 'YYYY-MM-DD').format('D MMMM')
